import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Crown } from "lucide-react";

const Header = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-gray-800">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <Crown className="h-8 w-8 text-yellow-400" />
            <span className="text-xl font-bold text-white tracking-wider">
              GOLDEN CORTEX
            </span>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-yellow-400 ${
                isActive("/") ? "text-yellow-400" : "text-white"
              }`}
            >
              HOME
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors hover:text-yellow-400 ${
                isActive("/services") ? "text-yellow-400" : "text-white"
              }`}
            >
              SERVICES
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors hover:text-yellow-400 ${
                isActive("/contact") ? "text-yellow-400" : "text-white"
              }`}
            >
              CONTACT
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;